module.exports = __webpack_public_path__ + "img/arrow-select.224c7a1f.svg";